<template>
    <v-layout row wrap v-redirect-if-no-permission:REGISTERED_CAPTAINS>
        <loading-component :value="loading"/>
        <v-dialog :value="!!select_user" @input="select_user = null" max-width="50%">
            <v-card v-if="!!select_user" class="elevation-1 pa-4">
                <choose-time v-model="select_user.from" label="From"/>
                <choose-time v-model="select_user.to" label="To"/>
                <v-select
                        label="Project"
                        :items="items"
                        item-value="id"
                        item-text="name"
                        v-model="select_user.project_id"></v-select>
                <v-btn @click="saveEvent">
                    Save
                </v-btn>
            </v-card>
        </v-dialog>
        <v-dialog :value="!!activeEvent" @input="activeEvent = null" max-width="50%">
            <v-card>
                <v-card-text class="title ">
                    Do you want to delete this schedule?
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="activeEvent = null">Cancel</v-btn>
                    <v-btn color="red" @click="deleteEvent">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-flex sm12>
            <v-toolbar
                    flat
            >
                <v-btn
                        fab
                        outline
                        small
                        absolute
                        left
                        color="blue"
                        @click="$refs.calendar.getApi().prev()"
                >
                    <v-icon dark>
                        keyboard_arrow_left
                    </v-icon>
                </v-btn>
                <v-btn
                        fab
                        outline
                        small
                        absolute
                        right
                        color="blue"
                        @click="$refs.calendar.getApi().next()"
                >
                    <v-icon
                            dark
                    >
                        keyboard_arrow_right
                    </v-icon>
                </v-btn>
            </v-toolbar>
            <full-calendar
                    ref="calendar"
                    default-view="timeGridWeek"
                    :events="events"
                    :droppable="false"
                    :editable="true"
                    :selectable="true"
                    :all-day-slot="false"
                    :business-hours="{startTime: '07:00:00', endTime:'23:59:59',daysOfWeek:[0,1,2,3,4,5,6]}"
                    slot-duration="00:15:00"
                    event-order="start"
                    :select-overlap="false"
                    :event-color="eventColor"
                    :plugins="calendarPlugins"
                    @select="select"
                    @eventDrop="eventDrop"
                    @datesRender="handleDateClick"
                    @eventClick="({event}) => activeEvent = event"
                    @eventResize="eventDrop"/>
        </v-flex>
    </v-layout>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import FullCalendar from "@fullcalendar/vue";
    import FullCalendarTimeGrid from "@fullcalendar/timegrid";
    import FullCalendarInteraction from "@fullcalendar/interaction";
    import moment from "moment";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseTime from "@/components/wasilni/input/ChooseTime";
    import ChooseUserMulti from "@/components/wasilni/input/ChooseUserMutli";


    export default {
        components: {LoadingComponent, ChooseUserMulti, ChooseTime, ChooseDate, FullCalendar},
        name: "UserProjectScheduleCalendar",
        title: "User Project Schedule",
        data() {
            return {
                date: null,
                loading: false,
                activeBooking: null,
                activeEvent: null,
                sliceInfoDialog: false,
                slice: null,
                data: [],
                start: null,
                end: null,
                select_user: null,
                items: null,
            }
        },
        computed: {
            calendarPlugins() {
                return [FullCalendarTimeGrid, FullCalendarInteraction];
            },
            events() {
                return this.data.map(this.scheduleToEvent);
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get(this.api.ACTIONS.PROJECT)
                .then(res => {
                    this.items = res.data.data.data
                })
                .catch(err => console.log(err))
                .finally(() => this.loading = false);
        },
        watch: {
            start() {
                this.getData();
            }
        },
        methods: {
            getData() {
                this.loading = true;
                this.axios.get(this.api.ACTIONS.USER_PROJECT_SCHEDULES, {
                    params: {
                        from: this.start,
                        to: this.end
                    }
                })
                    .then(
                        ({data: {data}}) => this.data = data
                    )
                    .finally(
                        () => this.loading = false
                    )
            },
            handleDateClick({view}) {
                this.start = moment(view.activeStart).format("YYYY-MM-DD");
                this.end = moment(view.activeEnd).format("YYYY-MM-DD");
            },
            eventColor({event}) {
                return event.color;
            },
            eventDrop({event, revert}) {
                if (moment(event.start).format("YYYY-MM-DD") !== moment(event.end).format("YYYY-MM-DD")) {
                    revert();
                    return;
                }
                this.loading = true;
                const from = moment(event.start).format("YYYY-MM-DD HH:mm");
                const to = moment(event.end).format("YYYY-MM-DD HH:mm");
                this.axios.put(this.api.ACTIONS.USER_PROJECT_SCHEDULES + '/' + event.id, {
                    from,
                    to,
                    now: false
                })
                    .catch(
                        revert
                    )
                    .finally(
                        () => this.loading = false
                    )
            },
            deleteEvent() {
                this.loading = true;
                this.axios.delete(this.api.ACTIONS.USER_PROJECT_SCHEDULES + '/' + this.activeEvent.id)
                    .then(
                        () => {
                            this.data = this.data.filter(({id}) => id != this.activeEvent.id)
                        }
                    )
                    .finally(
                        () => {
                            this.activeEvent = null;
                            this.loading = false
                        }
                    )
            },
            scheduleToEvent(data) {
                let colors = ["light-blue", "#90CA","#F4FF8", "#F48F", "#FF980"];
                return {
                    id: data.id,
                    title: data.project.name,
                    start: moment(data.from).toDate(),
                    end: moment(data.to).toDate(),
                    color: colors[data.project_id % colors.length]
                };
            },
            async saveEvent() {
                if (!this.select_user.project_id) {
                    alert("Enter Project");
                    return;
                }


                this.loading = true;
                try {
                    const {data: {data}} = await this.axios.post(
                        this.api.ACTIONS.USER_PROJECT_SCHEDULES,
                        this.select_user
                    );

                    this.data = [...this.data, data];
                    this.select_user = null;
                } catch (e) {
                    window.getApp.$emit("SHOW_TOAST", e.response.data.message, "red")
                } finally {
                    this.loading = false;
                }
            },
            select(info) {
                const {startStr, endStr} = info;


                if (moment(startStr).format("YYYY-MM-DD") === moment(endStr).format("YYYY-MM-DD")) {
                    const from = moment(startStr).format("YYYY-MM-DD HH:mm");
                    const to = moment(endStr).format("YYYY-MM-DD HH:mm");

                    this.select_user = {
                        project_id: null,
                        from,
                        to,
                        now: false
                    };

                } else {
                    alert('must be on same day');
                }
            }
        }
    }
</script>

<style scoped>
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/timegrid/main.css';

    div >>> .fc-toolbar.fc-header-toolbar {
        display: none;
    }

    .removebtn {
        color: black;
        position: absolute;
        top: 0;
        right: 0;
        width: 13px;
        height: 13px;
        text-align: center;
        border-radius: 50%;
        font-size: 10px;
        cursor: pointer;
        background-color: #FFF
    }
</style>
